<template>
  <portlet
          :icon="'fad fa-building'"
          :title="'Bedrijven'"
          :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'customer-create'}" class="btn btn-secondary btn-add-customer"
                   v-if="Can(rights.CUSTOMER_ADD)">
        <i class="fas fa-plus-circle mr-2"></i> Toevoegen
      </router-link>
      <a :href="$CLOUD_API+'/export/customers?access_token=' + this.$store.state.oAuthToken" v-if="Can(rights.CUSTOMER_VIEW)">
        <button class="btn btn-primary mr-4">
          <i class="fas fa-file-excel mr-2"></i> Exporteren naar Excel
        </button>
      </a>
    </template>
    <template slot="portletBody">

      <datatables
              v-if="getCustomersDataTable.length  && renderedComponent  && Can(rights.CUSTOMER_VIEW)"
              :tableClass="tableClass"
              tableID="customers"
              :rows="getCustomersDataTable"
              :columns="getColumns()"
              :tableInitOptions="tableInitOptions"
              routerLinkClass="dt-router-link"
              :deleteFunction="deleteCustomer"
              deleteClass="delete"
              :customFilters="customFilters"
      ></datatables>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from '../roles/rights.js';

  export default {
    mixins: [dataTables, swalModals],
    data() {
      return {
        isAdmin: false,
        customFilters: [],
        rights: '',
      };
    },
    methods: {
      Can,
      deleteCustomer(customer) {
        this.swalDelete(customer.name).then(result => {
          if(result.value) {
            this.$store.dispatch('customers/delete', customer.id);
            this.$toasted.global.successRequest({
              message: 'Bedrijf verwijderd'
            });
          }
        });
      },
      getColumns() {
        let self = this;
        return [
          {
            data: null, name: 'Bedrijf', visible: true, searchable: true, responsivePriority: 1,
            render(data) {
              return '<a data-to="/customers/' + data.id + '" class="dt-router-link">' + data.name + '</a>'
            }
          },
          {data: 'alias', name: 'Alias', visible: true, searchable: true},
          {data: 'location', name: 'Locatie', visible: true, searchable: true},
          {
            data: null, name: 'Verantwoordelijke', visible: true, searchable: true,
            render(data) {
              return data.responsibleUser ? data.responsibleUser.firstname + ' ' + data.responsibleUser.lastname : '';
            }
          },
          {
            data: null, name: 'Kostenplaats', visible: true, searchable: true,
            render(data) {
              return data.costCenter || '';
            }
          },
          {
            data: null, name: 'Aantal vacatures', visible: true, searchable: true,
            render(data) {
              return data.vacancies.length
              // return self.getVacanciesFromCustomer(data.id).length
            }
          },
          {
            data: null, name: 'Aantal plaatsingen', visible: true, searchable: true,
            render(data) {
              return data.placements.length
              // return self.getPlacementsFromCustomer(data.id).length
            }
          },
          {
            data: null, name: 'Opties', orderable: false, responsivePriority: 2,
            render(data) {
              var options = '';
              if(Can(RIGHTS.CUSTOMER_EDIT)) {
                options += '<a data-to="/customers/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>';
              } else {
                options += '<a data-to="/customers/' + data.id + '" class="action-icon dt-router-link"><i title="Bekijken" class="far fa-search"></i></a>'
              }

              if(Can(RIGHTS.CUSTOMER_DELETE)) {
                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              }
              return options;
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('customers', ['getCustomers','getCustomersDataTable']),
      ...mapGetters('vacancies', [
        'getVacancies',
        'getVacanciesFromCustomer'
      ]),
      ...mapGetters('placements', ['getPlacementsFromCustomer', 'getPlacements'])

    },
    created() {
      this.rights = RIGHTS;
      this.isAdmin = this.$store.state.users.me.admin;
    }
  };
</script>
